import {HTMLAttributes, ReactNode, useEffect, useRef, useState} from "react";
import {css, cx} from "@panda/css";
import {AnimatePresence, motion, useReducedMotion} from "framer-motion";

import {easeInOutMotionTransition} from "@/constants/ease_in_out_motion_transition";
import {useScrollExpandedAreaIntoView} from "@/hooks/use_scroll_expanded_area_into_view";

interface IProps extends HTMLAttributes<HTMLDivElement> {
    allowOverflow?: boolean;
    children: ReactNode;
    header: ReactNode;
    height?: number | "auto";
    isExpanded: boolean;
    onExitComplete?: () => void;
    shouldScrollIntoView?: boolean;
}

export const Collapsible = (props: IProps) => {
    const {allowOverflow = false, children, className, header, height = "auto", isExpanded, onExitComplete, shouldScrollIntoView = true, ...rootProps} = props;
    const sectionRef = useRef<HTMLDivElement>(null);
    const shouldReduceMotion = useReducedMotion();
    // overflow: hidden is only needed while height animates (0 -> auto) so the reveal looks like growth.
    // Switch to visible once settled so content (e.g. a carousel's box-shadow) isn't clipped permanently.
    const [isSettled, setIsSettled] = useState(false);
    // Keep the last body node after React unmounts it for AnimatePresence exit, so we can still force
    // overflow: hidden on it (the exiting element does not re-render).
    const bodyElRef = useRef<HTMLDivElement | null>(null);
    const {onAnimationComplete, onUpdate} = useScrollExpandedAreaIntoView({
        enabled: isExpanded && shouldScrollIntoView,
        sectionRef
    });

    useEffect(() => {
        if (!isExpanded) setIsSettled(false);
    }, [isExpanded]);

    const clipBodyOverflow = () => {
        // The exiting node does not re-render, so a settled `allowOverflow` section keeps
        // overflow: visible. Clip it for the height animation or the body paints over the next section.
        bodyElRef.current?.style.setProperty("overflow", "hidden", "important");
    };

    const handleAnimationComplete = () => {
        onAnimationComplete();
        if (!isExpanded) return;

        // Height is measured after mount, so the first complete can be 0 -> 0. Settling then
        // switches to `auto` and skips the real 0 -> height animation (and per-frame page scroll).
        if ((bodyElRef.current?.offsetHeight ?? 0) <= 1) return;

        bodyElRef.current?.style.removeProperty("overflow");
        setIsSettled(true);
    };

    return (
        <div className={className} ref={sectionRef} {...rootProps}>
            {header}
            <AnimatePresence initial={false} onExitComplete={onExitComplete}>
                {isExpanded && (
                    <motion.div
                        animate={{height: isSettled ? "auto" : height, opacity: 1}}
                        className={cx(bodyMotionShellStyle, (allowOverflow || isSettled) && bodyMotionShellSettledStyle)}
                        exit={{height: 0, opacity: 0}}
                        initial={{height: 0, opacity: 0}}
                        onAnimationComplete={handleAnimationComplete}
                        onAnimationStart={clipBodyOverflow}
                        onUpdate={onUpdate}
                        ref={(element) => {
                            if (element) bodyElRef.current = element;
                        }}
                        transition={shouldReduceMotion ? {duration: 0} : easeInOutMotionTransition}
                    >
                        {children}
                    </motion.div>
                )}
            </AnimatePresence>
        </div>
    );
};

const bodyMotionShellStyle = css({
    overflow: "hidden",
    width: "100%"
});

const bodyMotionShellSettledStyle = css({
    overflow: "visible!"
});
import {HTMLAttributes, ReactNode, useEffect, useRef, useState} from "react";
import {css, cx} from "@panda/css";
import {AnimatePresence, motion, useReducedMotion} from "framer-motion";

import {easeInOutMotionTransition} from "@/constants/ease_in_out_motion_transition";
import {useScrollExpandedAreaIntoView} from "@/hooks/use_scroll_expanded_area_into_view";

interface IProps extends HTMLAttributes<HTMLDivElement> {
    allowOverflow?: boolean;
    children: ReactNode;
    header: ReactNode;
    height?: number | "auto";
    isExpanded: boolean;
    onExitComplete?: () => void;
    shouldScrollIntoView?: boolean;
}

export const Collapsible = (props: IProps) => {
    const {allowOverflow = false, children, className, header, height = "auto", isExpanded, onExitComplete, shouldScrollIntoView = true, ...rootProps} = props;
    const sectionRef = useRef<HTMLDivElement>(null);
    const shouldReduceMotion = useReducedMotion();
    // overflow: hidden is only needed while height animates (0 -> auto) so the reveal looks like growth.
    // Switch to visible once settled so content (e.g. a carousel's box-shadow) isn't clipped permanently.
    const [isSettled, setIsSettled] = useState(false);
    // Keep the last body node after React unmounts it for AnimatePresence exit, so we can still force
    // overflow: hidden on it (the exiting element does not re-render).
    const bodyElRef = useRef<HTMLDivElement | null>(null);
    const {onAnimationComplete, onUpdate} = useScrollExpandedAreaIntoView({
        enabled: isExpanded && shouldScrollIntoView,
        sectionRef
    });

    useEffect(() => {
        if (!isExpanded) setIsSettled(false);
    }, [isExpanded]);

    const clipBodyOverflow = () => {
        // The exiting node does not re-render, so a settled `allowOverflow` section keeps
        // overflow: visible. Clip it for the height animation or the body paints over the next section.
        bodyElRef.current?.style.setProperty("overflow", "hidden", "important");
    };

    const handleAnimationComplete = () => {
        onAnimationComplete();
        if (!isExpanded) return;

        // Height is measured after mount, so the first complete can be 0 -> 0. Settling then
        // switches to `auto` and skips the real 0 -> height animation (and per-frame page scroll).
        if ((bodyElRef.current?.offsetHeight ?? 0) <= 1) return;

        bodyElRef.current?.style.removeProperty("overflow");
        setIsSettled(true);
    };

    return (
        <div className={className} ref={sectionRef} {...rootProps}>
            {header}
            <AnimatePresence initial={false} onExitComplete={onExitComplete}>
                {isExpanded && (
                    <motion.div
                        animate={{height: isSettled ? "auto" : height, opacity: 1}}
                        className={cx(bodyMotionShellStyle, (allowOverflow || isSettled) && bodyMotionShellSettledStyle)}
                        exit={{height: 0, opacity: 0}}
                        initial={{height: 0, opacity: 0}}
                        onAnimationComplete={handleAnimationComplete}
                        onAnimationStart={clipBodyOverflow}
                        onUpdate={onUpdate}
                        ref={(element) => {
                            if (element) bodyElRef.current = element;
                        }}
                        transition={shouldReduceMotion ? {duration: 0} : easeInOutMotionTransition}
                    >
                        {children}
                    </motion.div>
                )}
            </AnimatePresence>
        </div>
    );
};

const bodyMotionShellStyle = css({
    overflow: "hidden",
    width: "100%"
});

const bodyMotionShellSettledStyle = css({
    overflow: "visible!"
});
